import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function MapController({ regionToFocus }) {
  const map = useMap();
  useEffect(() => {
    if (regionToFocus?.center && regionToFocus.zoom != null) {
      map.flyTo(regionToFocus.center, regionToFocus.zoom, {
        duration: 1.0,
        easeLinearity: 0.25
      });
    }
    // MapContainer owns destruction. Leaflet.remove() cancels flight animation;
    // calling stop() here can access panes already removed by the parent.
  }, [map, regionToFocus]);
  return null;
}
